import ListAlt from '@material-ui/icons/ListAlt';
import AssignmentTurnedInOutlined from '@material-ui/icons/AssignmentTurnedInOutlined';
import EditOutlined from '@material-ui/icons/EditOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';

const rolesList = [
    'InternalAdminUser',
];

export const featuresList = {
    formBuilder: {
        jsonEditor: {
            name: 'JSON Editor',
            experimental: true,
            roles: rolesList,
        },
    },
    navDrawer: {
        navItems: [
            {
                key: 'forms',
                name: 'Forms',
                icon: AssignmentTurnedInOutlined,
                experimental: false,
            },
            {
                key: 'messages',
                name: 'Messages',
                icon: ListAlt,
                experimental: false,
            },
            {
                key: 'licensees',
                name: 'Licensees',
                icon: PersonOutlineOutlinedIcon,
                experimental: false,
            },
            {
                key: 'licenseTypes',
                name: 'License Types',
                icon: EditOutlined,
                experimental: true,
                roles: rolesList,
            },
            {
                key: 'feeTypes',
                name: 'Fee Types',
                icon: EditOutlined,
                experimental: true,
                roles: rolesList,
            },
            {
                key: 'workflows',
                name: 'Workflows',
                icon: EditOutlined,
                experimental: true,
                roles: rolesList,
            },
        ],
    },
};
